import { isExecutableLanguage } from "./codeBlockLanguages";

import type { Node as PMNode } from "@tiptap/pm/model";

export type ExecutableCodeBlocks = {
  active: PMNode[];
  removed: PMNode[];
};

function isExecutableCodeBlock(node: PMNode): boolean {
  const { cellId } = node.attrs;
  return (
    typeof cellId === "string" &&
    Boolean(cellId.trim()) &&
    isExecutableLanguage(node.attrs.language)
  );
}

export function collectExecutableCodeBlocks(doc: PMNode): ExecutableCodeBlocks {
  const active: PMNode[] = [];
  const removed: PMNode[] = [];

  doc.descendants((node) => {
    if (node.type.name === "changeRequestPart" && node.attrs.kind === "before") {
      node.descendants((removedNode) => {
        if (removedNode.type.name === "codeBlock" && isExecutableCodeBlock(removedNode)) {
          removed.push(removedNode);
        }
        return true;
      });
      return false;
    }

    if (node.type.name === "codeBlock" && isExecutableCodeBlock(node)) {
      active.push(node);
    }

    return true;
  });

  return { active, removed };
}
